<template>
    <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-65">
	        <md-card>
		        <md-card-header class="md-card-header-icon md-card-header-blue">
			        <div class="md-layout">
				        <div class="md-layout-item">
					        <div class="card-icon">
						        <font-awesome-icon class="md-icon" :icon="['fa', 'phone']" />
					        </div>
					        <h4 class="title">Liste des dernières demandes</h4>
				        </div>
			        </div>
		        </md-card-header>
		        <md-card-content>
			        <div>
				        <span class="font-bold">Filtres</span>
			        </div>
			        <div class="flex items-center justify-between mb-2.5">
				        <div style="min-width: 350px;">
					        <md-field>
						        <label>Recherche</label>
						        <md-input type="text" v-model="search" @input="searchDemands" />
						        <span class="md-helper-text">La recherche débute avec 3 caractères minimum</span>
					        </md-field>
				        </div>
				        <div style="min-width: 200px;">
					        <div class="md-multiselect">
						        <label>Éléments à afficher</label>
						        <multiselect v-model="pagination.perPage"
						                     :options="pagination.perPageOptions"
						                     :searchable="false"
						                     :show-labels="false"
						                     :allow-empty="false">
							        <template slot="noOptions">La liste est vide</template>
							        <template slot="noResult">Aucun élement correspondant</template>
						        </multiselect>
					        </div>
				        </div>
			        </div>
			        <div class="relative" style="min-height: 250px;">
				        <md-table :value="demands" class="paginated-table no-actions" table-header-color="blue"
				                  :md-sort-fn="getDemands"
				                  :md-sort.sync="sort.field"
				                  :md-sort-order.sync="sort.order">
					        <md-table-row v-if="demands.length > 0" slot="md-table-row" slot-scope="{ item }">
						        <md-table-cell md-label="Créateur" md-sort-by="creator" style="max-width: 25px;">
							        <div class="flex items-center">
								        <div class="creator-cube" :style="{ backgroundColor: item.creator.color && item.creator.color.includes('#') && item.creator.color.length === 7 ? item.creator.color : '#000000' }"></div>
								        <span class="ml-2 leading-none">{{ item.creator.first_name }}</span>
							        </div>
						        </md-table-cell>
						        <md-table-cell md-label="Date" md-sort-by="date">
							        <span>{{ $moment(item.date).format('DD/MM/YYYY à HH:mm') }}</span>
						        </md-table-cell>
						        <md-table-cell md-label="Modification" md-sort-by="last_infos">
							        <span>{{ item.last_infos ? $moment(item.last_infos).format('DD/MM/YYYY à HH:mm') : $moment(item.date).format('DD/MM/YYYY à HH:mm') }}</span>
						        </md-table-cell>
						        <md-table-cell md-label="Demande" md-sort-by="demand" style="min-width: 550px; width: 550px;">
							        <div>
								        <span v-if="item.client" class="text-success cursor-pointer uppercase hover:underline font-normal" @mousedown="goToRoute($event, 'Client Details', { id: item.client_id })">
									        {{ item.client.name }}
								        </span>
								        <span v-else class="text-danger uppercase">{{ item.prospect }}</span>
								        <span v-if="item.site" class="uppercase cursor-pointer hover:underline font-normal" @mousedown="goToRoute($event, 'Site Details', { id: item.client_id, idSite: item.site_id })">
	                                        {{' (' + item.site.name + ')' }}
	                                    </span>
								        <span v-else>{{ ' (aucun site)' }}</span>
							        </div>
							        <div class="flex items-center space-x-2">
								        <div class="button-icon-tooltip">
									        <md-button class="md-icon-button md-small-icon md-rounded-icon my-0 md-default cursor-default">
										        <font-awesome-icon class="md-icon" :icon="['fa', 'info']" />
									        </md-button>
									        <md-tooltip md-direction="top" :style="widthDemandTooltip(item.message)">
										        <div class="text-left">
											        <b>Message : </b>
											        {{ item.message }}
										        </div>
									        </md-tooltip>
								        </div>
								        <div class="text-info cursor-pointer hover:underline" @mousedown="goToRoute($event, 'Demand Details', { demandId: item.id })">
									        <template v-if="item.creator.type_id === 3">Demande du technicien {{ item.creator.full_name }}</template>
									        <template v-else>{{ item.subject }}</template>
								        </div>
							        </div>
						        </md-table-cell>
					        </md-table-row>
					        <md-table-empty-state v-if="!loader.demands"
					                              md-label="Pas de demandes trouvées"
					                              md-description="Essayez une recherche différente">
					        </md-table-empty-state>
				        </md-table>
				        <div v-if="loader.demands" class="loader-overlay opacity-100 absolute z-50 w-full h-full">
					        <div class="h-full w-full flex items-center justify-center">
						        <md-progress-spinner class="md-white" md-mode="indeterminate"
						                             :md-diameter="50" :md-stroke="4"></md-progress-spinner>
					        </div>
				        </div>
			        </div>
		        </md-card-content>
		        <md-card-actions md-alignment="space-between">
			        <p class="card-category">
				        Affichage des éléments {{ from + 1 }} à {{ to }} sur {{ pagination.total }} éléments
				        <span v-if="pagination.total !== 100 && pagination.total !== 0">(filtrés de 100 éléments au total)</span>
			        </p>
			        <pagination
				        class="pagination-no-border pagination-info"
				        v-model="pagination.currentPage"
				        :per-page="pagination.perPage"
				        :total="pagination.total"
				        @input="getDemands">
			        </pagination>
		        </md-card-actions>
	        </md-card>
        </div>
	    <div class="md-layout-item md-size-35">
		    <md-card>
			    <md-card-header class="md-card-header-icon md-card-header-blue">
				    <div class="md-layout">
					    <div class="md-layout-item">
						    <div class="card-icon">
							    <font-awesome-icon class="md-icon" :icon="['fa', 'list']" />
						    </div>
						    <h4 class="title">Actions à réaliser</h4>
					    </div>
				    </div>
			    </md-card-header>
			    <md-card-content>
				    <div class="relative" style="min-height: 100px;" :class="{ 'min-h-0': tasks.length === 0 }">
					    <template v-if="!loader.tasks">
						    <template v-if="tasks.length > 0">
							    <div class="task-row leading-5 mb-2" v-for="task in tasks" :key="task.id">
								    <div>
									    <font-awesome-icon class="md-icon" :icon="['far', 'check-square']" />
									    <span class="mb-0">{{ textTask(task.demand) }}</span>
									    <span class="mb-0 mx-1">|</span>
									    <span class="text-info cursor-pointer hover:underline" @mousedown="goToRoute($event, 'Demand Details', { demandId: task.demand.id })">Voir</span>
								    </div>
								    <div>
									    <b class="font-medium mb-0">{{ task.task_type.name }}</b>
									    <template v-if="task.text">
										    <span class="font-medium mb-0 ml-1">|</span>
										    <span class="mb-0 ml-1">{{ task.text }}</span>
									    </template>
								    </div>
							    </div>
						    </template>
						    <p v-else>Aucune tâche en cours.</p>
					    </template>
					    <div v-else class="loader-overlay opacity-100 absolute z-50 w-full h-full">
						    <div class="h-full w-full flex items-center justify-center">
							    <md-progress-spinner class="md-white" md-mode="indeterminate"
							                         :md-diameter="50" :md-stroke="4"></md-progress-spinner>
						    </div>
					    </div>
				    </div>
			    </md-card-content>
		    </md-card>
		    <md-card style="margin-top: 40px;">
			    <md-card-header class="md-card-header-icon md-card-header-blue">
				    <div class="md-layout">
					    <div class="md-layout-item">
						    <div class="card-icon">
							    <font-awesome-icon class="md-icon" :icon="['fa', 'wrench']" />
						    </div>
						    <h4 class="title">Notes de mise à jour</h4>
					    </div>
				    </div>
			    </md-card-header>
			    <md-card-content>
				    <div>
					    <p class="font-medium leading-4">Légende</p>
					    <div class="flex items-center space-x-8">
						    <div class="flex items-center space-x-2">
							    <div class="changelog-tag admin"></div>
							    <span>Administration</span>
						    </div>
						    <div class="flex items-center space-x-2">
							    <div class="changelog-tag mobile"></div>
							    <span>Application mobile</span>
						    </div>
						    <div class="flex items-center space-x-2">
							    <div class="changelog-tag client-area"></div>
							    <span>Espace Client</span>
						    </div>
					    </div>
				    </div>
				    <md-divider class="mb-3 mt-1.5"></md-divider>
<!--				    <div class="changelog">
					    <div class="changelog-row">
						    <p class="leading-4 font-bold text-primary mb-1">Dernières informations importantes</p>
						    <div class="mb-1.5">
							    <div class="flex items-center space-x-2">
								    <div class="changelog-tag admin"></div>
								    <p class="leading-4 font-medium">Ajout du module Outil</p>
							    </div>
						    </div>
					    </div>
				    </div>
					<md-divider class="mb-3 mt-1.5"></md-divider>-->
				    <div class="changelog">
					    <div v-for="(log, index) in logs" :key="log.date" class="changelog-row mb-3">
						    <p class="leading-4 font-bold text-primary mb-1">{{ log.date }}</p>
						    <div v-for="(note, i) in log.notes" :key="log.date + '-' + i" class="mb-1.5">
							    <div class="flex items-start space-x-2">
								    <div class="changelog-tag mt-0.5" :class="note.tag"></div>
								    <p class="leading-4 font-medium">{{ note.title }}</p>
							    </div>
							    <p class="leading-4">{{ note.text }}</p>
						    </div>
						    <md-divider v-if="index !== (logs.length - 1)" class="mt-3 mr-2"></md-divider>
					    </div>
				    </div>
			    </md-card-content>
		    </md-card>
	    </div>
    </div>
</template>

<script>
// Components
import { Pagination } from "@/components";

// Mixins
import routerMixin from "../../mixins/router-mixin";
import tablePaginationMixin from "../../mixins/table-pagination-mixin";

export default {
    name: 'Dashboard',
	components: {
		Pagination
	},
    mixins: [routerMixin, tablePaginationMixin],
    data() {
        return {
			loader: {
				demands: true,
				tasks: true,
			},
	        search: null,
	        pagination: {
		        perPage: 25,
		        total: 0
	        },
	        sort: {
				field: 'last_infos',
		        order: 'desc',
	        },
			demands: [],
            tasks: [],
	        logs: [
				{
					date: '07/07/2022',
					notes: [
						{ tag: 'admin', title: 'Ajout de la génération des rapports d\'interventions avec plans pour le type d\'intervention "MAINTENANCE DEIV "' }
					]
				},
                {
					date: '23/06/2022',
					notes: [
						{ tag: 'admin', title: 'Correction d\'un problème d\'affichage dans la page des factures' }
					]
				},
                {
					date: '02/06/2022',
					notes: [
						{ tag: 'client-area', title: 'Correction d\'un bug qui empêchait l\'affichage de la liste des interventions' }
					]
				},
                {
					date: '09/05/2022',
					notes: [
						{ tag: 'admin', title: 'Le commentaire de la prévision est désormais copié dans le commentaire de l\'intervention après la planification' }
					]
				},
				{
					date: '04/05/2022',
					notes: [
						{ tag: 'admin', title: 'Correction d\'un bug dans la gestion et le calendrier',
							text: 'Les interventions ayant des horaires chevauchant 2 jours n\'apparaissaient pas'
						}
					]
				},
		        {
			        date: '28/04/2022',
			        notes: [
				        { tag: 'admin', title: 'Correction d\'un bug lors de la sauvegarde des données dans un plan d\'intervention (#2810)' }
			        ]
		        },
		        {
			        date: '14/04/2022',
			        notes: [
				        { tag: 'admin', title: 'Correction de la date de planification des interventions qui ne correspondait pas avec le plan d\'intervention (#2726)' },
				        { tag: 'admin', title: 'Correction d\'un bug lors de la mise en "non réalisable" d\'une intervention depuis la gestion' },
			        ]
		        },
                {
                    date: '06/04/2022',
                    notes: [
                        { tag: 'admin', title: 'Correction de la liste des interventions mal planifiées afin qu\'elles apparaissent toutes pour l\'année séléctionné (#2795)' },
                    ]
                },
                {
                    date: '29/03/2022',
                    notes: [
                        { tag: 'admin', title: 'Correction d\'un bug lors de la modification d\'un site (#2763)' },
                        { tag: 'admin', title: 'Correction d\'un bug lors de la suppression d\'une intervention ponctuelle (#2770)' },
                    ]
                },
                {
                    date: '23/03/2022',
                    notes: [
                        { tag: 'admin', title: 'Correction d\'un bug d\'enregistrement des rapports de dispositifs (#2702)' },
                    ]
                },
		        {
			        date: '17/03/2022',
			        notes: [
				        { tag: 'admin', title: 'Ajout du module Outil' },
			        ]
		        },
                {
                    date: '11/03/2022',
                    notes: [
                        { tag: 'admin', title: 'Optimisation du chargement de la page de création des interventions (#2687)' },
                    ]
                },
                {
                    date: '08/03/2022',
                    notes: [
                        { tag: 'client-area', title: 'Ajout de l\'interface de changement de mot de passe dans l\'espace client' },
                    ]
                },
                {
                    date: '03/03/2022',
                    notes: [
                        { tag: 'admin', title: 'A. Miramond retiré des destinataires de l\'email concernant la suppression d\'une intervention (#2630)' },
                        { tag: 'mobile', title: 'Correction du bug des rapports de dispositifs sur les quantités',
                            text: 'Une quantité à 0 est désormais bien enregistrée en tant que "Aucune"'
                        },
                        { tag: 'admin', title: 'Mise en place de différentes couleurs de thème pour différencier les environnements',
                            text: 'Rouge : Production | Vert : Preproduction'
                        },
                    ]
                },
		        {
			        date: '01/03/2022',
			        notes: [
				        { tag: 'admin', title: 'Correction du bug d\'affichage des données des contrats (#2568)', text: 'Ajout de conditions sur la date de résiliation' },
				        { tag: 'admin', title: 'Correction de la liste des interventions sans contrat actifs (statistiques)' },
				        { tag: 'admin', title: 'Correction de la recherche dans le tableau des interventions pour un client ou un site (#2597)' },
			        ]
		        },
				{
					date: '07/02/2022',
					notes: [
						{ tag: 'admin', title: 'Lien sur la date d\'intervention vers le planning',
							text: 'Dans la page d\'un client et d\'un site, un lien vers le planning a été ajouté sur la date d\'intervention dans le tableau'
						},
            			{ tag: 'admin', title: 'Ajout de l\'historique d\'une intervention dans la popup du calendrier' },
						{ tag: 'admin', title: 'Lors de la création d\'un plan, la date est désormais au format jj/mm/aaaa' },
						{ tag: 'mobile', title: 'Correction de bugs d\'affichage sur les plans. (#2460 / #2493)',
							text: 'Correction de la taille des icônes des dispositifs. Correction du titre qui pouvait disparaître.'
						},
						{ tag: 'admin', title: 'Correction d\'un bug qui empêchait la sauvegarde du commentaire d\'intervention dans la gestion' },
						{ tag: 'admin', title: 'Correction d\'un bug qui empêchait la sauvegarde des rapports de dispositif SMART' },
						{ tag: 'admin', title: 'Ajout du rôle dans la liste des contacts dans la modification d\'un site' },
						{ tag: 'admin', title: 'Le bug ne listant pas toutes les interventions sans contrats actifs a été corrigé (#2500)' },
						{ tag: 'admin', title: 'Correction du bug de filtrage des données dans la gestion (#2511)' },
					]
				},
		        {
			        date: '26/01/2022',
			        notes: [
				        { tag: 'admin', title: 'Correction d\'un bug d\'affichage sur les tableaux du rapport d\'intervention.' },
				        { tag: 'mobile', title: 'La liste des derniers rapports d\'intervention est désormais correctement récupérée (#2489)' },
				        { tag: 'client-area', title: 'Ajout du lien vers le nouvel espace client dans les mails automatique de rapport d\'intervention' },
			        ]
		        },
                {
			        date: '24/01/2022',
			        notes: [
						{ tag: 'admin', title: 'Mise en place de la page Statistiques' },
				        { tag: 'admin', title: 'Affichage des bon types de dispositifs sur les plans.', text: 'Affichage des types de dispositifs présent dans le rapport si le plan est dans le rapport' },
				        { tag: 'admin', title: 'Refonte de la page Contrats et ajout de filtres (échéance et tacit reconduction)' },
				        { tag: 'admin', title: 'Mise en place de la page Sites', text: 'Liste les sites en Appatage non permanent avec un filtre "SMART"' },
				        { tag: 'admin', title: 'Mise en place des demandes sur le Tableau de bord' },
				        { tag: 'admin', title: 'Une intervention peut désormais être clôturée depuis la page de détail d\'une intervention' },
				        { tag: 'admin', title: 'La raison pour supprimer une intervention est désormais obligatoire' },
				        { tag: 'admin', title: 'Il est désormais possible de modifier la catégorie d\'une intervention', text: 'Disponible lors de la modification de la planification uniquement pour les interventions hors contrat.' },
				        { tag: 'admin', title: 'Correction de l\'affichage des contacts (#2378)', text: 'La liste des contacts sur la page de détail d\'un client est désormais paginée. Les numéros de téléphone sont désormais formatés.' },
				        { tag: 'admin', title: 'Correction de la connexion vers l\'Espace Client depuis l\'administration',
					        text: 'Les boutons situés sur la page de détail d\'un client et d\'un site sont désormais fonctionnels. Il est maintenant possible d\'ajouter un compte Espace Client à un site.' },
				        { tag: 'admin', title: 'Le message dans le mail d\'envoi des rapports d\'intervention a été modifié (#2447)' },
				        { tag: 'mobile', title: 'La liste des derniers rapports d\'intervention est désormais correctement récupérée' },
				        { tag: 'client-area', title: 'La liste des sites présent sur la page des Prestations est désormais pleinement ouverte (#2433)' },
			        ]
		        },
		        {
			        date: '17/01/2022',
			        notes: [
				        { tag: 'admin', title: 'Ajout des niveaux de consommation dans les rapports où ils n\'étaient pas déjà présent (#2434)' },
				        { tag: 'admin', title: 'Envoi automatique des rapports d\'interventions aux clients (Magali les reçois pour le moment)' },
			        ]
		        },
                {
			        date: '13/01/2022',
			        notes: [
				        { tag: 'admin', title: 'Correction des liens présents sur la page de détails d\'un contrat (#2425)' },
				        { tag: 'admin', title: 'Correction de la sélection des dispositifs dans la modification d\'un plan (#2427)' },
				        { tag: 'mobile', title: 'La récupération des données a été optimisée (récupération plus rapide)' },
			        ]
		        },
		        {
			        date: '04/01/2022',
			        notes: [
				        { tag: 'admin', title: 'Correction sur la création et l\'édition du planning d\'intervention (#2319)' },
                        { tag: 'admin', title: 'Correction sur l\'accès et la modification des détails d\'un site (#2137)' },
                        { tag: 'admin', title: 'Affichage d\'un message d\'erreur si la copie d\'un contrat a expirée (#2309)' },
                        { tag: 'admin', title: 'Affichage des unités de produits dans les rapports d\'interventions PDF (#2195)' },
                        { tag: 'mobile', title: 'Ajout du numéro de mobile d\'un contact RDV dans le détail d\'une intervention (#2350)' },
                    ]
		        },
		        {
			        date: '16/12/2021',
			        notes: [
                        { tag: 'admin', title: 'Correction sur l\'enregistrement des commentaire sur le plan d\'intervention (#2311)' },
                        { tag: 'admin', title: 'Correction de la liste des contrats à facturer (#2320)', text: 'Récupération des contrats avec une date de résiliation en fin de mois' },
                    ]
		        },
                {
			        date: '08/12/2021',
			        notes: [
                        { tag: 'admin', title: 'Correction de l\'affichage des contacts', text: 'Affichage des contacts actifs dans la liste d\'un client ou d\'un site' },
                    ]
		        },
                {
			        date: '03/12/2021',
			        notes: [
                        { tag: 'admin', title: 'Correction du formulaire d\'ajout d\'une intervention ponctuelle', text: 'Optimisation du chargement des années' },
                        { tag: 'admin', title: 'Correction du mauvais affichage de la légende d\'un plan' },
                    ]
		        },
                {
			        date: '26/11/2021',
			        notes: [
                        { tag: 'admin', title: 'Correction bug sur les groupements', text: 'Affichage des dispositif à ajouter.' },
                        { tag: 'admin', title: 'Correction sur la modification des dispositifs d\'un site' , text: 'Correction d\'un bug permettant de modifier le type d\'un dispositif en un type utilisant une fiche de suivi différente' },
                        { tag: 'admin', title: 'Correction du bug de rafraîchissement dans le calendrier', text: 'Correction d\'un bug empêchant de rafraîchir une cellule de calendrier dans certains cas' }
                    ]
		        },
		        {
			        date: '24/11/2021',
			        notes: [
                        { tag: 'admin', title: 'Correction bug sur la facturation', text: 'Récupération des bons contrats sur la page de facturation et ajout clique molette.' }
                    ]
		        },
                {
			        date: '23/11/2021',
			        notes: [
				        { tag: 'admin', title: 'Modification sur les périodes de contrat (#2124)', text: 'Ajout de la possibilité de modifier les dates de début et de fin de la 1ère période d\'un contrat. Correction de l\'affichage des périodes de contrat' },
				        { tag: 'admin', title: 'Correction sur la gestion (#2149 / #2148 / #2007)', text: 'Correction des prévisions d\'interventions affichées dans la gestion. Corrections sur la carte. Corrections sur le panier' },
				        { tag: 'admin', title: 'Améliorations des performances à la génération des pdf', text: 'Amélioration des performances à la génération des pdf de plans et de rapports d\'interventions' }
                    ]
		        },
		        {
			        date: '19/11/2021',
			        notes: [
				        { tag: 'mobile', title: 'Récupération des données', text: 'Les 2 boutons de mise à jour permettent désormais de récupérer soit 2 jours soit 6 jours. Une date de synchronisation est affichée sur la page du planning' },
				        { tag: 'mobile', title: 'Correction du bug de récupération des données', text: 'Mise à jour 6 jours : Correction du bug qui n\'affichait pas le planning entier après avoir récupéré toutes les données' },
			        ]
		        },
		        {
			        date: '10/11/2021',
			        notes: [
				        { tag: 'admin', title: 'Ajout de la génération automatique de nouvelles périodes de contrat', text: 'Génération de périodes de contrat une fois par semaine et envoi d\'un mail avec la liste des périodes créées' },
				    ]
		        },
		        {
			        date: '09/11/2021',
			        notes: [
				        { tag: 'admin', title: 'Listes des dispositif d\'une intervention', text: 'Correction du bug qui a fait disparaitre la liste des dispositifs sur une intervention'}
                    ]
		        },
                {
			        date: '08/11/2021',
			        notes: [
				        { tag: 'admin', title: 'Mauvais contrat facturation (#1988)', text: 'Récupération des bons contrats sur la page de facturation'},
				        { tag: 'admin', title: 'Dispositifs dans les mauvaises interventions', text: 'Récupération des bons dispositifs par rapport au type d\'intervention et récupération du groupement si présent dans le plan d\'intervention'},
                        { tag: 'mobile', title: 'Dispositifs dans les mauvaises interventions', text: 'Récupération des bons dispositifs par rapport au type d\'intervention'},
                        { tag: 'mobile', title: 'Affichage du planning', text: 'La page du planning affiche désormais uniquement les journées et les interventions disponibles.'},
                    ]
		        },
                {
			        date: '29/10/2021',
			        notes: [
                        { tag: 'admin', title: 'Correction de l\'erreur sur le champ de recherche des factures (#2014)'},
                        { tag: 'admin', title: 'Correction sur le nombre de passage par an dans les rapports PDF d\'intervention (#2013)'},
                        { tag: 'admin', title: 'Correction sur l\'affichage des contrats d\'un site/client (#2000)'},
                        { tag: 'admin', title: 'Correction sur la suppression des contacts d\'un client (#2002)'},
                        { tag: 'admin', title: 'Correction de la limite de caractère du nom d\'un document (#2015)'},
			        ]
		        },
                {
			        date: '27/10/2021',
			        notes: [
                        { tag: 'mobile', title: 'Mise en ligne de la nouvelle version de l\'application mobile'},
                        { tag: 'admin', title: 'Correction du chargement infini dans la liste des interventions d\'un site (#2001)'},
                        { tag: 'admin', title: 'Modification de la durée de l\'intervention depuis la page de détail (#1985)'},
                        { tag: 'admin', title: 'Ajout des notes dans le détail d\'une intervention (#1978)'},
                        { tag: 'admin', title: 'Changement des heures par défaut d\'une intervention de 23h à 01h (#1980)'},
				        { tag: 'admin', title: 'Passage du titre du plan sur plusieurs lignes (#1989)'},
			        ]
		        },
                {
			        date: '26/10/2021',
			        notes: [
				        { tag: 'admin', title: 'Correction modification des dispositifs d\'un site (#1984)', text: 'Correction de l\'erreur du numéro déjà utilisé'},
				        { tag: 'admin', title: 'L\'affichage des rapports précédents pour tous les types d\'intervention (#1987)'},
				        { tag: 'admin', title: 'Modification de la durée d\'engagement accessible à l\'édition d\'un contrat (#1983)'},
			        ]
		        },
                {
                    date: '25/10/2021',
                    notes: [
                        { tag: 'admin', title: 'Correction des doublons des rapports de dispositifs', text: 'Correction des doublons dans la liste des dispositifs sur la page de détail d\'une intervention' },
                        { tag: 'admin', title: 'Placement des dispositifs sur les plans (#1968)', text: 'Les dispositifs peuvent désormais être placés sur tout le plan (superposition). Également disponible sur la version mobile' },
                        { tag: 'admin', title: 'Affichage du titre du plan est désormais fonctionnel' },
                    ]
                },
                {
                    date: '22/10/2021',
                    notes: [
	                    { tag: 'mobile', title: 'Gestion des données de l\'application mobile',
		                    text: 'Après la connexion, seules les données de la journée actuelle sont récupérées.\n' +
			                    'Il y a désormais 2 boutons pour récupérer les données : 1 pour la journée et 1 pour le planning global\n' +
			                    'Il y a désormais aussi un bouton pour envoyer manuellement les modifications en cas de faible réseau\n' +
			                    'Les données proviennent désormais du cache donc les temps de chargement ont grandement été réduit'
	                    },
                        { tag: 'admin', title: 'Mise à jour de la liste des raison de résiliation de contrat'},
                        { tag: 'admin', title: 'Correction de la duplication d\'un contract (#1957)'},
                        { tag: 'admin', title: 'Correction des doublons de dispositifs', text: 'Les doublons dans l\'édition des dispositifs d\'un site ont été corrigés'},
                        { tag: 'mobile', title: 'Correction des doublons des rapports de dispositifs (#1960)', text: 'Afin d\'éviter les doublons d\'envoi de formulaire, une vérification a été ajoutée sur chaque formulaire de l\'application mobile' },
                    ]
                },
		        {
			        date: '21/10/2021',
			        notes: [
				        { tag: 'admin', title: 'Création d\'une demande depuis un client ou un site', text: 'Le temps chargement de la page de création a été réduit et un overlay de chargement a été ajouté' },
				        { tag: 'mobile', title: 'L\'envoi des modifications hors-ligne n\'est plus automatique', text: 'Désormais pour envoyer les modifications réalisées hors-ligne, un bouton a été ajouté sur le tableau de bord' },
			        ]
		        },
		        {
			        date: '20/10/2021',
			        notes: [
				        { tag: 'mobile', title: 'Ajout d\'une action dans une demande', text: 'Le nombre de caractères pour le texte d\'une action n\'est désormais plus limité' },
				        { tag: 'admin', title: 'Lien "Assistance"', text: 'Le lien "Assistance" contacte désormais le support de Nixie' },
				        { tag: 'admin', title: 'Changement d\'état d\'une demande', text: 'Le changement d\'état des demandes est de nouveau fonctionnel' },
				        { tag: 'admin', title: 'Liste des demandes', text: 'Pour les demandes non traitées, la colonne des actions donne désormais le nombre d\'actions en cours' },
				        { tag: 'admin', title: 'Détails d\'une demande', text: 'Le lien vers le site amène de nouveau sur la bonne page.\nUn envoi de mail aux techniciens à désormais pour éxpéditeur le mail "expert"' },
			        ]
		        },
		        {
					date: '19/10/2021',
			        notes: [
				        { tag: 'admin', title: 'Règle sur le numéro de contrat', text: 'Le numéro de contrat n\'est plus unique et une information apparait si il est déjà utilisé' },
				        { tag: 'admin', title: 'Modification du nom d\'un plan de site', text: 'Le nom d\'un plan de site est de nouveau fonctionnel' },
				        { tag: 'admin', title: 'Actualisation des données du calendrier', text: 'Une icône de rafraichissement est disponible dans chaque case du calendrier pour actualiser ses données' },
				        { tag: 'admin', title: 'Correction de la génération de PDF', text: 'La génération de PDF est de nouveau fonctionnel' },
				        { tag: 'admin', title: 'Modifier une journée du calendrier', text: 'La durée prévu de l\'intervention est disponible à côté de la durée réelle' },
				        { tag: 'admin', title: 'Liste des techniciens dans le calendrier', text: 'Les lignes de technicien sont désormais fermer par défaut' },
				        { tag: 'admin', title: 'Transfert d\'intervention', text: 'La modification des horaires de l\'intervention est désormais disponible dans le panel de transfert' },
				        { tag: 'admin', title: 'Filtres des techniciens', text: 'La limitation à 3 techniciens a été supprimé et les techniciens non actif n\'apparaissent plus dans la liste' },
				        { tag: 'admin', title: 'Résiliation d\'une période dans le préavis', text: 'Une période peut désormais être résilié même si nous sommes dans la période de préavis. À la place, un message d\'information est affiché' },
				        { tag: 'admin', title: 'Nombre de caractère du titre du document', text: 'Le titre du document peut désormais contenir plus de caractères (150, anciennement 45)' },
				        { tag: 'mobile', title: 'Génération PDF après cloture intervention', text: 'Après la cloture d\'une intervention sur l\'application mobile, le rapport PDF est généré automatiquement' },
				        { tag: 'mobile', title: 'Type d\'intervention sur le planning', text: 'Le type d\'intervention est affiché sur le planning de l\'application mobile' },
				        { tag: 'mobile', title: 'Couleurs des interventions', text: 'Les couleurs pour identifier les interventions sur l\'application mobile sont plus marquées' },
				        { tag: 'mobile', title: 'Taille de la typographie', text: 'La taille des textes a été augmenté sur le planning' },
				        { tag: 'mobile', title: 'Interventions validées et terminées', text: 'Seuls les interventions "validées" et "terminées" sont listées sur le planning l\'application mobile' },
			        ]
		        }
	        ],
        }
    },
	methods: {
		async getDemands() {
			const { data } = await this.$store.dispatch('demands/getDashboardDemands', {
				page: this.pagination.currentPage,
				perPage: this.pagination.perPage,
				search: this.search,
				sort: this.sort,
				limit: 100
			})

			this.demands = data.demands
			this.pagination.total = data.total
			this.loader.demands = false
		},
		widthDemandTooltip(message) {
			return message.length > 50 && message.length < 200 ? { minWidth: '350px !important' } :
				(message.length > 200 ? { minWidth: '600px !important' } : { maxWidth: 'max-content !important' })
		},
		searchDemands(event) {
			if(event.length === 0 || event.length >= 3) {
				this.getDemands()
			}
		},
        async getActions() {
			this.loader.tasks = true
            const { data } = await this.$store.dispatch('demands/getActionsAuth')
            this.tasks = data
	        this.loader.tasks = false
        },
        textTask(demand) {
            let text

            if (demand.client_id) {
                text = demand.client.name
                if (demand.site_id) text += ' (' + demand.site.name + ')'
            } else text = demand.prospect

            return text
        },
    },
    mounted() {
		this.getDemands()
        this.getActions()
    }
};
</script>

<style lang="scss" scoped>
.task-row {
    &:last-child {
        margin-bottom: 0 !important;
    }

	.md-icon {
		width: 100%;
		max-width: 12px;
		height: 15px;

		margin-top: -1px;
		margin-left: -2px;

		color: $brand-primary;
	}
}

.changelog {
    max-height: 750px;
    overflow-y: auto;
	padding-right: 10px;
}

.changelog-tag {
    width: 12px;
	min-width: 12px;
    height: 12px;
	min-height: 12px;
    border-radius: 3px;

    &.admin {
        background: $brand-danger;
    }

    &.mobile {
        background: $brand-info;
    }

	&.client-area {
		background: $brand-warning;
	}
}

</style>
